import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { PatientService } from '@app/_services';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private accountService: PatientService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const patient = this.accountService.patientInfo;
        if (patient) {
            return true;
        }
        else 
        {

            this.router.navigate(['/account/login'],{queryParams:{returnUrl:state.url}});
            return false;
        }
    }
}